/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_5_ClientInputs */

const et_portfolio_project_5_client = /** @type {(inputs: Portfolio_Project_5_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House of Om (Jooga- ja heaolukeskus)`)
};

const en_portfolio_project_5_client = /** @type {(inputs: Portfolio_Project_5_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House of Om (Yoga and wellness studio)`)
};

/**
* | output |
* | --- |
* | "House of Om (Yoga and wellness studio)" |
*
* @param {Portfolio_Project_5_ClientInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_5_client = /** @type {((inputs?: Portfolio_Project_5_ClientInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_5_ClientInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_5_client(inputs)
	return en_portfolio_project_5_client(inputs)
});